module.exports = __webpack_public_path__ + "img/eeb0764.webp";